module.exports = "/_next/static/images/9385ccc70f982d687708e0598e99c226-image-right-lg.jpg.webp";